import { createContext, PropsWithChildren, useContext, useEffect, useState } from "react";
import { getProfileInformation } from "../api";

interface SessionContextData {
  profile: {
    id: number
    deviceId: string
    email: string
    name: string
    ipv4: string
    locked: boolean
    createdAt: string
  };
  isAuthenticated: boolean
  logout: () => void
  fetchProfile: () => Promise<void>
}

const SessionContext = createContext({} as SessionContextData);

export function SessionProvider(props: PropsWithChildren) {
  const { children } = props;

  const [profile, setProfile] = useState<any>();
  const [isAuthenticated, setAuthenticated] = useState<boolean>(!!localStorage.getItem("deviceId"))

  const fetchProfile = async () => {
    try {
      const userProfile = await getProfileInformation();
      if (!userProfile || userProfile.length === 0) {
        setAuthenticated(false)
        setProfile(undefined)
      } else {
        setProfile(userProfile);
        setAuthenticated(true)
      }
    } catch (error) {
      setProfile(undefined);
      setAuthenticated(false)
    }
  };

  const logout = () => {
    localStorage.removeItem("deviceId")
    setAuthenticated(false)
    setProfile(undefined)
  }

  useEffect(() => {
    if (localStorage.getItem("deviceId")) {
      setAuthenticated(true)
    }

    fetchProfile();
  }, []);

  return (
    <SessionContext.Provider value={{ profile, logout, fetchProfile, isAuthenticated }}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  const context = useContext(SessionContext)
  return context
}